module.exports = __webpack_public_path__ + "img/ysf.270a9ca6.png";